/**
 * Loewe-style scroll reveal using IntersectionObserver.
 * Adds .is-revealed class to sections as they enter the viewport.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  const sections = document.querySelectorAll('.content-for-layout > .shopify-section');
  if (!sections.length) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });
})();
